import KeplerSdk from './../../keplerSdk.js'

const state = {
    subscriptions: [],
    subscriptionsLastFetch: null,
}

const mutations = {
    SET_SUBSCRIPTIONS_LIST (state, message) {
        state.subscriptions = message
    },
    SET_SUBSCRIPTIONS_LAST_FETCH (state, message) {
        state.subscriptionsLastFetch = message
    },
}

const actions = {
    sample_call_all: ({dispatch, commit}, payload) => {
        //dispatch('fetchSubscriptions')
    },
    fetchSubscriptions: ({commit}, payload) => {
        if (state.subscriptionsLastFetch == null) {
            KeplerSdk.getSubscriptions(function (data) {
                commit('SET_SUBSCRIPTIONS_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_SUBSCRIPTIONS_LIST', data)
            }, function (error) {

            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/subscriptionsStore.js